import { render } from "./TeilnehmerZugriffListe.vue?vue&type=template&id=bee58b10&ts=true"
import script from "./TeilnehmerZugriffListe.vue?vue&type=script&lang=ts"
export * from "./TeilnehmerZugriffListe.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__